(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/wager/assets/javascripts/create-wager-object.js') >= 0) return;  svs.modules.push('/components/lb-utils/wager/assets/javascripts/create-wager-object.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const currencyAsJupiterString = svs.utils.format.CurrencyAsJupiterString;
const SYSTEMS = svs.components.sport.systems.SYSTEMS;
const MSYS = 'MSYS';
const USYS = 'USYS';
const RSYS = 'RSYS';
function getSystemType(system) {
  const firstChar = system[0].toLowerCase();
  if (firstChar === 'm') {
    return MSYS;
  }
  if (firstChar === 'r') {
    return RSYS;
  }
  if (firstChar === 'u') {
    return USYS;
  }
  return system;
}
function getSizeFromRow(row, system, systemType) {
  if (systemType === RSYS || systemType === USYS) {
    const _system$split = system.split('-'),
      _system$split2 = _slicedToArray(_system$split, 3),
      size = _system$split2[2];
    return Number(size);
  }
  let size = 1;
  for (let i = 0; i < row.length; ++i) {
    size *= row[i].length;
  }
  return size;
}
function getSystemNum(system, systemType) {
  if (systemType === MSYS) {
    return 1;
  }
  if (systemType === RSYS || systemType === USYS) {
    return SYSTEMS[system].systemNum;
  }
}
function createWagerObject(_ref) {
  let productId = _ref.productId,
    drawNumber = _ref.drawNumber,
    cost = _ref.cost,
    row = _ref.row,
    isCompetition = _ref.isCompetition,
    isXperten = _ref.isXperten,
    system = _ref.system;
  const betProperties = [];
  if (isCompetition) {
    betProperties.push('COMPETITION');
  }
  const systemType = getSystemType(system);
  const wager = {
    crc: 0,
    marketInfo: 0,
    bagType: 0,
    bets: [{
      productId,
      drawNum: drawNumber,
      betAmountSalesGroup1: currencyAsJupiterString(cost),
      betAmountSalesGroup2: '0,00',
      game1X2Boards: [{
        boardData: row,
        boardProps: [isXperten ? 'WEIGHTEDQP' : null].filter(Boolean),
        numSelections: getSizeFromRow(row, system, systemType),
        rowPriceMulti: 1,
        systemNum: getSystemNum(system, systemType),
        systemType: [systemType]
      }],
      rowPriceMulti: 1,
      numDraws: 1,
      betProperties
    }]
  };
  return wager;
}
setGlobal('svs.lbUtils.wager.createWagerObject', createWagerObject);

 })(window);